import request from '@/utils/request'

/**
 * 获取图片验证码
 * GET /prod-api/captchaImage
 * 返回: { msg, img (base64), code, captchaEnabled, uuid }
 */
export function getCaptchaImage() {
  return request({
    url: '/captchaImage',
    method: 'get'
  })
}

/**
 * 登录
 * POST /prod-api/login
 * @param {Object} data { username, password, code, uuid }
 * 返回: { msg, code, token }
 */
export function login(data) {
  return request({
    url: '/login',
    method: 'post',
    data
  })
}

/**
 * 获取当前用户信息（登录后调用，获取角色权限等）
 * GET /prod-api/getInfo
 */
export function getInfo() {
  return request({
    url: '/getInfo',
    method: 'get'
  })
}

/**
 * 获取当前用户的路由菜单
 * GET /prod-api/getRouters
 * 返回: 菜单路由树
 */
export function getRouters() {
  return request({
    url: '/getRouters',
    method: 'get'
  })
}

/**
 * 退出登录
 * POST /prod-api/logout
 */
export function logout() {
  return request({
    url: '/logout',
    method: 'post'
  })
}
